(function () {
    angular
        .module("app")
        .service("PageService", PageService);


    PageService.$inject = ["$state"];

    function PageService($state) {
        var svc = {};
        window._pageService = svc;

        // TODO: remove this - for dev only
        svc._pageInfo = {
            info:"dev info only - not programmatic",
            resultsCount:"",
            pageSize:"",
            currentPage:"",
            totalPagesInList:"",
            pageNumberStart:""
        };
        svc.loadPropsAndMethods = function(callerScope){

            callerScope.pages = [];

            // Set current page list indices
            callerScope.setPageList = function(){
                const windowWidth = $(window).width();

                let maxPageToDisplay = 10;
                if(windowWidth<=690) maxPageToDisplay = 8;
                if(windowWidth<=610) maxPageToDisplay = 6;
                if(windowWidth<=540) maxPageToDisplay = 5;
                if(windowWidth<=450) maxPageToDisplay = 4;
                if(windowWidth<=400) maxPageToDisplay = 3;


                const middlePosition = Math.ceil(maxPageToDisplay/2)-1;
                const resultsCount = callerScope.currentSearch.resultsCount;
                const pageSize = callerScope.currentSearch.pageSize;

                let currentPage = callerScope.currentSearch.currentPage;
                if(currentPage * pageSize > resultsCount){
                    currentPage = Math.ceil(resultsCount / pageSize);
                    if(currentPage>0){
                        callerScope.currentSearch.currentPage = currentPage;
                    }
                }

                const totalPagesInList = Math.ceil(resultsCount / pageSize);
                let pageNumberStart = 1;
                let pageNumberEnd = maxPageToDisplay;

                if(totalPagesInList<=maxPageToDisplay){
                    pageNumberStart = 1;
                    pageNumberEnd = totalPagesInList;
                }
                else
                {
                    if(currentPage<=middlePosition){
                        pageNumberStart = 1;
                        pageNumberEnd = maxPageToDisplay;
                    }
                    else
                    {
                        pageNumberEnd = Math.min(currentPage+middlePosition, totalPagesInList);
                        pageNumberStart = Math.max(pageNumberEnd-maxPageToDisplay+1,1);
                    }
                }


                // TODO: remove this - for dev only
                svc._pageInfo.resultsCount = resultsCount;
                svc._pageInfo.pageSize = pageSize;
                svc._pageInfo.currentPage = currentPage;
                svc._pageInfo.totalPagesInList = totalPagesInList;
                svc._pageInfo.pageNumberStart = pageNumberStart;

                const indexArray = [];
                
                for (let i = pageNumberStart; i <= pageNumberEnd; i++) {
                    indexArray.push({
                        index: i,
                        current: (i==callerScope.currentSearch.currentPage)
                    })
                }

                let nextPage = (totalPagesInList > currentPage)
                  ? {index:callerScope.currentSearch.currentPage+1,current:false}
                  : {index:totalPagesInList,current:true}

                let prevPage = (callerScope.currentSearch.currentPage > 1)
                  ? {index:callerScope.currentSearch.currentPage-1,current:false}
                  : {index:1,current:true};

                //callerScope.pages = {indices:indexArray,prevPage:prevPage,nextPage:nextPage};
                callerScope.pageNav = {pages:indexArray,prevPage:prevPage,nextPage:nextPage};
                callerScope.currentSearch.showingFrom = ((currentPage-1) * pageSize)+1;
                callerScope.currentSearch.showingTo = Math.min(callerScope.currentSearch.currentPage*callerScope.currentSearch.pageSize,callerScope.currentSearch.resultsCount);
                callerScope.currentSearch.showingRange = `${callerScope.currentSearch.showingFrom} to ${callerScope.currentSearch.showingTo} of ${callerScope.currentSearch.resultsCount}`
                
            };

            // ======================================================
            // callerScope.setNewPage - page click function
            // ======================================================
            callerScope.setNewPage = function(page) {
                if(page == null){
                    page = {
                        index:1,
                        current:false
                    }
                }
                if(true){
                    let v = callerScope.views.length ? callerScope.views.join(',') : '0';
                    let t = callerScope.buckets[v].name;
                    const routeParams = {
                        q: callerScope.searchTerm,
                        v: v,
                        tab: t,
                        page: page.index
                    }
                    $state.go(callerScope.route.name,routeParams)
                }
                else
                {
                    callerScope.setPage(page)
                }
            };


            // ======================================================
            // callerScope.setNewPage - set page on new state
            // ======================================================
            callerScope.setPage = function(page){
                
                if(page == null){
                    page = {
                        index:1,
                        current:false
                    }
                }

                if(!page.current && !callerScope.currentSearch.shroud){

                    let _useSoftScrollTop = callerScope.useSoftScrollTop || false;
                    const _scrollDelay = _useSoftScrollTop ? 400 : 10;

                    setTimeout(function(){
                            $("html, body").animate({ scrollTop: 0 }, _scrollDelay);
                    },90);

                    callerScope.currentSearch.currentPage = page.index;
                    callerScope.setPageList();
                    if(typeof callerScope.onSetPage == 'function'){
                        callerScope.onSetPage(page);
                    }
                }
            };
        };

        return svc;
    }


})();